export enum SlackMessageTypes {
  DIRECTS = 'directs',
  CHANNELS = 'channels',
}

export enum SlackConversationType {
  CHANNEL = 'channel',
  DIRECT = 'direct',
}

export const SLACK_TAB_PARAM = 'tab';
